import React from 'react';
import {
  IOption,
  ApButtonGroup,
  ApButtonOrange,
  ApButtonSecondary,
  ApRadio,
} from '@alixpartners/ui-components';
import {
  StyledModal,
  WarningArea,
  RadioWrapper,
  RadioList,
  RadioLabel,
  TextWarning,
} from './ReuseAllocationModal.styles';

interface IAllocatedOption extends IOption {
  isAllocated?: boolean;
}

interface IState {
  selectedDate: string | null;
}

interface IProps {
  isOpen: boolean;
  onSubmit(year: number): void;
  onClose(): void;
  options: IAllocatedOption[] | null;
  body?: string;
}

export class ReuseAllocationModal extends React.Component<IProps, IState> {
  state = {
    selectedDate: null as IState['selectedDate'],
  };

  handleDateChange = (e: React.BaseSyntheticEvent) => {
    const value = e.target.value;

    this.setState({ selectedDate: value });
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { selectedDate } = this.state;

    if (!selectedDate) {
      return;
    }

    onSubmit(Number(selectedDate));
  };

  render() {
    const { isOpen, onClose, options, body } = this.props;
    const { selectedDate } = this.state;

    return (
      <StyledModal
        isOpen={isOpen}
        header="Reuse spend allocation from a different time period"
        isDismissible
        hasClosed={onClose}
        footer={({ handleClose }) => {
          return (
            <ApButtonGroup justifyContent="flex-end">
              <ApButtonSecondary onClick={handleClose}>
                {options ? 'Cancel' : 'Ok, got it'}
              </ApButtonSecondary>
              {options && (
                <ApButtonOrange
                  disabled={!selectedDate}
                  onClick={this.handleSubmit}
                >
                  Reuse data from time period
                </ApButtonOrange>
              )}
            </ApButtonGroup>
          );
        }}
      >
        {options ? (
          <span>
            {body ? (
              body
            ) : (
              <>
                You can reuse the application spend allocation from a different
                time period by selecting from the list below. We will allocate
                the spend using the same category (e.g. service tower/vendor/job
                title) and then reuse those allocated percentages, where
                possible.
              </>
            )}
          </span>
        ) : (
          <span>
            There are no time periods with allocated spend.
            <br />
            <br />
            To reuse allocated spend, at least one time period should have spend
            allocated.
          </span>
        )}
        <WarningArea>
          Please be aware that any saved allocation data from your current time
          period will be overwritten.
        </WarningArea>
        {options && (
          <RadioList>
            {options.map((item) => (
              <RadioWrapper key={item.value}>
                <ApRadio
                  id={item.value}
                  name="allocation-inherit"
                  value={item.value}
                  checked={selectedDate === item.value}
                  onChange={this.handleDateChange}
                  disabled={!item.isAllocated}
                >
                  <RadioLabel disabled={!item.isAllocated}>
                    {item.label}
                    {!item.isAllocated && (
                      <TextWarning>No allocation</TextWarning>
                    )}
                  </RadioLabel>
                </ApRadio>
              </RadioWrapper>
            ))}
          </RadioList>
        )}
      </StyledModal>
    );
  }
}
